import React from "react"

import { useState } from "react"
import { Button } from "../components/ui/button"
import { Input } from "../components/ui/input"
import { Check } from "lucide-react"

export function NewsletterForm() {
  const [email, setEmail] = useState("")
  const [submitted, setSubmitted] = useState(false)

  const handleSubmit = (e) => {
    e.preventDefault()
    setSubmitted(true)
  }

  if (submitted) {
    return (
      <div className="p-4 text-center bg-green-50 rounded-lg">
        <div className="flex items-center justify-center mb-2">
          <div className="p-2 bg-green-100 rounded-full">
            <Check className="w-6 h-6 text-green-600" />
          </div>
        </div>
        <h3 className="mb-1 font-medium">Thank you for subscribing!</h3>
        <p className="text-sm text-muted-foreground">You'll receive our latest updates in your inbox.</p>
      </div>
    )
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="flex flex-col gap-4 sm:flex-row">
        <Input
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className="flex-1"
        />
        <Button type="submit">Subscribe</Button>
      </div>
      <p className="text-xs text-center text-muted-foreground">
        By subscribing, you agree to our Privacy Policy and consent to receive updates from our company.
      </p>
    </form>
  )
}
